import React from 'react'

const OpenToOtherFleetsModal = ({ isOpen, onConfirm, onCancel, preferredFleetName }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
        <div className="p-4 border-b">
          <h3 className="text-lg font-semibold text-gray-900">Open to other fleet operators?</h3>
        </div>
        <div className="p-4 space-y-3">
          <p className="text-sm text-gray-700">
            {preferredFleetName ? (
              <>Preferred fleet <span className="font-medium">{preferredFleetName}</span> declined or did not respond in time.</>
            ) : (
              <>The preferred fleet declined or did not respond in time.</>
            )}
          </p>
          <p className="text-sm text-gray-600">
            Would you like to open this booking to other selected partner fleets? If yes, we will route the request to them on a first-come, first-served basis.
          </p>
        </div>
        <div className="p-4 border-t flex items-center justify-end gap-2">
          <button
            type="button"
            className="px-4 py-2 rounded-md text-sm bg-gray-100 hover:bg-gray-200 text-gray-800"
            onClick={onCancel}
          >
            No, stop booking
          </button>
          <button
            type="button"
            className="px-4 py-2 rounded-md text-sm bg-blue-600 hover:bg-blue-700 text-white"
            onClick={onConfirm}
          >
            Yes, open to others
          </button>
        </div>
      </div>
    </div>
  )
}

export default OpenToOtherFleetsModal


